import React from 'react';
import { connect } from 'react-redux';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import SideMenu from './SideMenu';
import './Main.css';
import { history } from '../helpers';
import Projects from './projects/Projects';
import ProjectDetails from './projects/ProjectDetails';
import Directory from './directory/Directory';
import EmployeeDetails from './directory/EmployeeDetails';
import Settings from './settings/Settings';
import NewOrEditProjectDialog from './dialog/NewOrEditProjectDialog';
import ProjectDialog from './dialog/ProjectDialog';
import InviteDialog from './dialog/InviteDialog';
import RemovePendingInvitationDialog from './dialog/RemovePendingInvitationDialog';
import RemoveProjectMemberDialog from './dialog/RemoveProjectMemberDialog';
import EditProjectMemberDialog from './dialog/EditProjectMemberDialog';
import EditTeamMemberDialog from './dialog/EditTeamMemberDialog';
import PremiumDialog from './dialog/PremiumDialog';
import PremiumSuccessDialog from './dialog/PremiumSuccessDialog';

class Main extends React.Component {
  renderDialog() {
    const hash = history.location.hash;
    const newOrEditProject = hash === '#newProject' || hash === '#editProject';
    const closeOrReopenProject =
      hash === '#closeProject' || hash === '#reopenProject';
    const invite = hash === '#invite' || hash === '#invitePremium';
    const removePendingInvitation = hash === '#removeInvitation';
    const removeProjectMember = hash === '#removeProjectMember';
    const editProjectMember = hash === '#editProjectMember';
    const editTeamMember = hash === '#editTeamMember';
    const premium = hash === '#premium' || hash === '#invitePremium';
    const premiumSuccess = hash === '#premiumSuccess';

    return (
      <div>
        {newOrEditProject && (
          <NewOrEditProjectDialog {...history.location.state} />
        )}
        {closeOrReopenProject && <ProjectDialog {...history.location.state} />}
        {invite && <InviteDialog {...history.location.state} />}
        {removePendingInvitation && (
          <RemovePendingInvitationDialog {...history.location.state} />
        )}
        {removeProjectMember && (
          <RemoveProjectMemberDialog {...history.location.state} />
        )}
        {editProjectMember && (
          <EditProjectMemberDialog {...history.location.state} />
        )}
        {editTeamMember && <EditTeamMemberDialog {...history.location.state} />}
        {premium && <PremiumDialog backOnClose={hash === '#invitePremium'} />}
        {premiumSuccess && <PremiumSuccessDialog {...history.location.state} />}
      </div>
    );
  }
  render() {
    return (
      <div className="dashboard-root">
        {this.renderDialog()}
        <SideMenu />
        <div className="dashboard-content">
          <Router history={history}>
            <Switch>
              <Route exact path="/projects" component={Projects} />
              <Route path="/projects/:id" component={ProjectDetails} />
              <Route exact path="/directory" component={Directory} />
              <Route path="/directory/:id" component={EmployeeDetails} />
              <Route path="/settings" component={Settings} />
              <Route render={() => <Redirect to="/projects" />} />
            </Switch>
          </Router>
        </div>
      </div>
    );
  }
}

export default connect()(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js